export default "__VITE_ASSET__ZDiomHPZ__"